import React, { Component } from 'react';
import CriteriaMenuBar from './CriteriaMenuBar';
import CriteriaTable from './CriteriaTable';
import SearchBox from './SearchBox';

export default class CriteriaWidget extends Component {
    constructor(props) {
        super(props);
        // this.handleSelectionBoxChange = this.handleSelectionBoxChange.bind(this);
        // this.handleSelectAllSector = this.handleSelectAllSector.bind(this);
        // this.handleMenuChange = this.handleMenuChange.bind(this);
        // this.handleScoreBoxChange = this.handleScoreBoxChange.bind(this);
        this.state = {
            section: "basic",
            fromPreset:props.fromPreset
        };
    }
    handleSelectionBoxChange = (name, value, ischecked) => {
        this.props.handleSelectionBoxChange(name, value, ischecked);
    }
    handleCriteriaBoxChange = (name, value, criteriavalues, cb) => {
        this.props.handleCriteriaBoxChange(name, value, criteriavalues, cb, false);
    }
    handleMenuChange = (section) => {
        this.setState({ section });
    }
    handleSelectAllMarket = () => {
        this.props.handleSelectAllMarket();
    }
    handleSelectAllSector = () => {
        this.props.handleSelectAllSector();
    }
    handleScoreBoxChange = (index, disabled, value) => {
        this.props.handleScoreBoxChange(index, disabled, value);
    }
    handleInvestAmtChange = (investamt) => {
        this.props.handleInvestAmtChange(investamt);
    }
    handleSearch = () => {
        this.props.handleSearch(true);
    }
    isSelectAllMarketChecked = () => {
        return this.props.isSelectAllMarketChecked();
    }
    isSelectAllSectorChecked = () => {
        return this.props.isSelectAllSectorChecked();
    }
    clearAll = () => {
        this.props.clearAll();
    }
    render() {
        return (
            <div>
                <CriteriaMenuBar criteria={this.props.criteria} showErrMsg={this.props.showErrMsg} section={this.state.section} onMenuChange={this.handleMenuChange} />
                <SearchBox name="SearchBoxTop" data={this.props.data} onSearch={this.handleSearch} hiddenCount={true}/>
                <CriteriaTable token={this.props.token} fromPreset={this.props.fromPreset} section={this.state.section} handleSelectionBoxChange={this.handleSelectionBoxChange} handleCriteriaBoxChange={this.handleCriteriaBoxChange} handleSelectAllMarket={this.handleSelectAllMarket} isSelectAllMarketChecked={this.isSelectAllMarketChecked} handleSelectAllSector={this.handleSelectAllSector} isSelectAllSectorChecked={this.isSelectAllSectorChecked} handleScoreBoxChange={this.handleScoreBoxChange} handleInvestAmtChange={this.handleInvestAmtChange} criteria={this.props.criteria} data={this.props.data.criteria_result_counts} />
                <SearchBox hvClean={true} clearAll={this.clearAll} name="SearchBox" data={this.props.data} onSearch={this.handleSearch} />
            </div>
        );
    }
}